import { TConfig, OPERAND_TYPE } from "../constants/constants";

export function hasLeftOperands(config: TConfig): config is TConfig & { leftOperands: OPERAND_TYPE[] } {
  return 'leftOperands' in config;
}

export function hasRightOperands(config: TConfig): config is TConfig & { rightOperands: OPERAND_TYPE[] } {
  return 'rightOperands' in config;
}

export function hasOperands(config: TConfig): config is TConfig & { operands: OPERAND_TYPE[] } {
  return 'operands' in config;
}